import classNames from 'classnames'

import type { Image } from 'types'
import { useMediaQuery } from 'ui-component-library/components/MediaQuery'
import style from './style.scss'

function useBackgroundImageURL(image: Image) {
  const { belowMobile, belowTablet } = useMediaQuery({
    mobile: true,
    tablet: true,
  })

  if (typeof image.src === 'string') {
    return image.src
  }

  const { medium, large, hero, heroLarge } = image.src

  if (belowMobile) {
    return medium
  } else if (belowTablet) {
    return large
  } else if (heroLarge) {
    return heroLarge
  } else if (hero) {
    return hero
  } else {
    return large
  }
}

type Props = {
  className?: string
  children: React.ReactNode
  image: Image
  gradient?: boolean
}

function BackgroundImage({
  children,
  image,
  className,
  gradient = true,
}: Props) {
  const backgroundImageURL = useBackgroundImageURL(image)

  return (
    <div
      className={classNames(style.wrapper, className, {
        [style.gradient]: gradient,
      })}
      style={{ backgroundImage: `url(${backgroundImageURL})` }}
    >
      {children}
    </div>
  )
}

export default BackgroundImage
